import { message as _message, notification as _notification, Modal as _Modal, Input } from "antd";
import React from "react";

export class Message {
    public info = (content: string, duration: number = 2) => {
        _message.info(content, duration);
    };

    public success = (content: string, duration: number = 2) => {
        _message.success(content, duration);
    };

    public error = (content: string, duration: number = 2) => {
        _message.error(content, duration);
    };

    public warning = (content: string, duration: number = 2) => {
        _message.warning(content, duration);
    };

    public loading = (content: string, duration: number = 2) => {
        _message.loading(content, duration);
    };
}

export class Notification {
    public open = (msg: string, description: string) => {
        _notification.open({
            message: msg,
            description: description,
        });
    };

    public success = (msg: string, description: string) => {
        _notification.success({
            message: msg,
            description: description,
        });
    };

    public info = (msg: string, description: string) => {
        _notification.info({
            message: msg,
            description: description,
        });
    };

    public warning = (msg: string, description: string) => {
        _notification.warning({
            message: msg,
            description: description,
        });
    };

    public error = (msg: string, description: string) => {
        _notification.error({
            message: msg,
            description: description,
        });
    };
}

export class AntModal {
    public open = (content: string) => {
        _Modal.info({
            icon: null,
            content: content,
            centered: true,
        });
    };

    public info = (title: string, content: string) => {
        _Modal.info({
            title: title,
            content: content,
        });
    };

    public success = (content: string) => {
        _Modal.success({
            content: content,
        });
    };

    public error = (title: string, content: string) => {
        _Modal.error({
            title: title,
            content: content,
        });
    };

    public warning = (title: string, content: string) => {
        _Modal.warning({
            title: title,
            content: content,
        });
    };

    public confirm = (
        title: string,
        content: React.ReactNode | string,
        value: any,
        callback: (value: any, action?: any) => void,
        okText: string = "OK",
        cancelText: string = "Cancel",
    ) => {
        _Modal.confirm({
            title: title,
            content: content,
            okText: okText,
            cancelText: cancelText,
            centered: true,
            onOk: () => {
                callback(value, "ok");
            },
            onCancel: () => {
                callback(value, "cancel");
            },
        });
    };

    public confirmCheckbox = (
        title: string,
        content: string,
        event: any,
        value: any,
        callback: (event: any, value: any, action?: any) => void,
        okText: string = "OK",
    ) => {
        _Modal.confirm({
            title: title,
            content: content,
            okText: okText,
            centered: true,
            onOk: () => {
                callback(event, value, "ok");
            },
            onCancel: () => {
                callback(event, value, "cancel");
            },
        });
    };

    public confirmWithComment = (
        title: string,
        message: string,
        value: any,
        callback: (value: any, comment: string, action?: "ok" | "cancel") => void,
        okText: string = "OK",
    ) => {
        const commentHolder = { current: "" };

        const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            commentHolder.current = e.target.value;
        };

        return new Promise((resolve, reject) => {
            _Modal.confirm({
                title,
                content: (
                    <div>
                        <p>{message}</p>
                        <Input.TextArea rows={4} maxLength={255} showCount placeholder="Enter your comment..." onChange={handleChange} />
                    </div>
                ),
                okText,
                centered: true,
                onOk: () => {
                    if (!commentHolder.current.trim()) {
                        // block OK if comment is empty
                        return Promise.reject(new Error("Comment is required."));
                    }
                    callback(value, commentHolder.current, "ok");
                    return Promise.resolve();
                },
                onCancel: () => {
                    callback(value, commentHolder.current, "cancel");
                },
            });
        });
    };
}
